import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CartService } from 'src/app/services/dhukan/cart.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-ordersdetails',
  templateUrl: './ordersdetails.component.html',
  styleUrls: ['./ordersdetails.component.css']
})
export class OrdersdetailsComponent implements OnInit {

  
  @Input() cartid:number=0
  
  @Output() emitData = new EventEmitter();

  
  checkname:string="";
  OrderMainColl:any=[];
  OrderMainBO:any={};
  OrderDetailsColl:any=[];
  OrderStatusColl:any=[];
  OrderPayColl:any=[];

  
  //Cancel Validation
  cancelsubmitted:boolean;
  cancelsuccessfully:boolean;


  //Save Validation
  submitted:boolean;
  successfully:boolean;

  constructor(public cartservice: CartService,public loginservice:LoginDataService,public activeModal: NgbActiveModal) { 


  }

  ngOnInit() {
     
  }

  

  
  
  fnInitializeCancelOrderFormGroup(){
    
  }

  fnGetOrderDetails(){
      var data = {
        'cartid':this.cartid
      }

    
    this.loginservice.fnGetOrder(data)
        .subscribe(
          (res)=>{                  
            if(res.json().status==200){              
             
              let _result = res.json().result;
              
              console.log(_result)
              this.OrderMainColl=_result.ordermain;     
                    
              if(this.OrderMainColl.length>0){            
                this.OrderMainBO=this.OrderMainColl[0];
              }          
             
                        
              this.OrderDetailsColl=_result.orderdetails;  
              this.OrderPayColl=_result.orderpay;            
              this.OrderStatusColl = _result.statusdetails;  
              
              console.log(this.OrderStatusColl)
              
            }
            else if(res.json().status==400){                          
              this.fnShowErrorMsg('Error'+res.json().err_field);
            }          
          },
          (err)=>{          
            this.fnShowErrorMsg('Error'+ err);
          })
  }
  

   fnClose(){
    this.activeModal.close(false);
  }

  
  // fngetInvoiceByOrder(){
  
  //       var data = {
  //         'orderid':this.OrderMainBO.orderid,                 
  //       }

      
  //       this.loginservice.fnGetInvoiceByOrder(data)
  //         .subscribe(
  //           (res)=>{                  
  //             if(res.json().status==200){     
  //               let url=res.json().result.downloadurl;
  //               window.open(url, "_blank");    
          
  //             }
  //             else if(res.json().status==400){                          
  //               this.fnShowErrorMsg('Error'+res.json().err_field);
  //             }           
  //           },
  //           (err)=>{          
  //             this.fnShowErrorMsg('Error'+ err);
  //         })
      


     
  // }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.activeModal.close(true)
  }

  private  fnShowErrorMsg(ex){
    console.log(ex);       
  }



}
